import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
// import { get } from 'lodash'
import { ButtonGroup, Button } from 'components/misc'
import styles from './question.styl'

export default class Question extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    editQuestion: PropTypes.func.isRequired,
    removeQuestion: PropTypes.func.isRequired,
    editCustomizationEnabled: PropTypes.bool
  }

  handleRenderTemplate = (question, editCustomizationEnabled) => {
     return(<div>
      <div className={styles.questionWrap}>
        <span className={styles.question}>{question.translatedText}</span>
        <span className={styles.btn}>
          {editCustomizationEnabled && <ButtonGroup>
            <Button
              tiny
              negative
              intlKey="button.remove"
              onClick={() => this.props.removeQuestion(question.id)}
            >
              Remove
            </Button>
            <Button
              tiny
              secondary
              intlKey="button.edit"
              onClick={() => this.props.editQuestion(question.id)}
            >
              Edit
            </Button>
          </ButtonGroup>}
        </span>
      </div>
    </div>
  )}

  handleRenderText = ({ id, defaultMessage } = {}) => {
    const { question, editCustomizationEnabled } = this.props

    return (
      <div className={styles.item}>
        {this.handleRenderTemplate(question, editCustomizationEnabled)}
        <span className={styles.values}>
          <FormattedMessage
            id="label.possible_values"
            defaultMessage="Possible values:"
          />{' '}
          <FormattedMessage
            id={id || 'label.any_string'}
            defaultMessage={defaultMessage || 'ANY STRING'}
          />
        </span>
      </div>
    )
  }

  handleRenderOptions = () => {
    const { question, editCustomizationEnabled } = this.props

    return (
      <div className={styles.item}>
        {this.handleRenderTemplate(question, editCustomizationEnabled)}
        <span className={styles.values}>
          <FormattedMessage
            id="label.possible_values"
            defaultMessage="Possible values:"
          />{' '}
          {this.handleRenderOptionValues(question.profileQuestionOptions)}
        </span>
      </div>
    )
  }

  handleRenderOptionValues = (values = []) => {
    const namedValues = values.map(item => item.translatedText)

    return namedValues.join(', ')
  }

  render() {
    const { question } = this.props

    let content = null

    switch (question.questionType) {
      case 'TEXT':
        content = this.handleRenderText()
        break
      case 'DATE':
        content = this.handleRenderText({
          id: 'label.date',
          defaultMessage: 'Date'
        })
        break
      case 'OPTIONS':
        content = this.handleRenderOptions()
        break
      case 'INTEGER':
        content = this.handleRenderText({
          id: 'label.integer',
          defaultMessage: 'Integer'
        })
        break
      case 'EMAIL':
        content = this.handleRenderText({
          id: 'label.email',
          defaultMessage: 'Email'
        })
        break

      default:
        break
    }

    return <div>{content}</div>
  }
}
